import { Card, Col, Statistic, Typography } from 'antd';
import React from 'react';
import { shallowEqual } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useTypedSelector } from '../../../store';
import CopyButton from '../../UI/Button/CopyButton';

const { Text } = Typography;

type Props = {
  title: string | React.ReactNode;
  value: number;
  compensationOn: boolean;
};

export const ResultInterest = () => {
  const { t } = useTranslation();
  const { principalAmountOpt } = useTypedSelector(state =>
    state.sumUp.lawsuitOpts, shallowEqual);
  return (
    <>
      {principalAmountOpt !== 'PRINCIPAL_INTEREST' ? (
        <>
          <Text type="secondary">{t('resultInterest.sum')}</Text>
          <br />
        </>
      ) : null }
      <Text type="secondary">{principalAmountOpt !== 'PRINCIPAL_INTEREST' ? t('resultInterest.capitalized') : t('resultInterest.Capitalized')}</Text>
    </>
  );
};
export const ResultComp = () => {
  const { t } = useTranslation();
  const { principalAmountOpt } = useTypedSelector(state =>
    state.sumUp.lawsuitOpts, shallowEqual);
  return (
    <>
      {principalAmountOpt !== 'PRINCIPAL_INTEREST' ? (
        <>
          <Text type="secondary">{t('resultInterest.sum')}</Text>
          <br />
        </>
      ) : null }
      <Text type="secondary">{principalAmountOpt !== 'PRINCIPAL_INTEREST' ? t('resultInterest.capitalized') : t('resultInterest.Capitalized')}</Text>
      <br />
      <Text type="secondary">{t('resultInterest.compensations')}</Text>
    </>
  );
};

const ResultCard = (
  {
    title,
    value,
    compensationOn
  }: Props
) => {
  return (
    <Col
      md={{ span: compensationOn ? 8 : 12 }}
      xs={{ span: 24 }}
    >
      <Card>
        <div style={{
          height: 160,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',

        }}
        >
          <Statistic
            title={title}
            value={value}
            precision={2}
            decimalSeparator=","
            groupSeparator=" "
          />
          <CopyButton
            value={value ? value.toFixed(2).replace(/\./g, ',') : ''}
          />
        </div>
      </Card>
    </Col>
  );
};



export default ResultCard;
